// extracted by mini-css-extract-plugin
module.exports = {"h4":"product_card-module--h4--34XCJ","link":"product_card-module--link--1ecyq","item":"product_card-module--item--2rmXk"};